import React, { useEffect, useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { getVideos } from "../services/movieService";
import { spiritualFilterData } from "../utils/spiritualFilterData";
import ReactGA from 'react-ga4'
import { captureEvent } from "../services/analytics/eventCapture";

const Spiritual = () => {
	const navigate = useNavigate();
	const [videos, setVideos] = useState([]);
	const [selectedFilter, setSelectedFilter] = useState("For You");
	const [languageFilter, setLanguageFilter] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const [loading, setLoading] = useState(false);

	const fetchVideos = async (search, filter) => {
		try {
			setLoading(true);
			const data = await getVideos(search, filter);
			setVideos(data);
			setLoading(false);
		} catch (error) {
			console.log("Error fetching movies:", error);
		}
	};

	useEffect(() => {
		ReactGA.send({ hitType: "pageview", page: "/spiritual", title: "Spiritual | Chimera | Euler Motors" });
		fetchVideos(null, null);
	}, []);

	const handleLanguageFilterClose = () => {
		if (languageFilter) {
			setLanguageFilter(!languageFilter);
		}
	};

	const handleFilterClick = (filter) => {
		captureEvent('Spiritual', "Spiritual_Filter", filter)
		setSearchTerm("");
		setSelectedFilter(filter);

		if (filter === "For You") {
			fetchVideos(null, null);
		} else {
			fetchVideos(null, filter);
		}
	};
	const handleSearchChange = (e) => {
		setSearchTerm(e.target.value);
	};

	const searchSpiritualContent = () => {
		captureEvent("Spiritual", "Spiritual_Search", searchTerm)
		fetchVideos(searchTerm, null);
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			searchSpiritualContent();
		}
	};

	return (
		<div className="w-[100vw] h-full bg-[#202124] flex flex-col overflow-x-hidden " onClick={() => handleLanguageFilterClose()}>
			<div className="w-full bg-[#202124] flex flex-col px-5">
				{/* MENU SECTION */}
				<div className="flex flex-col w-full mx-auto bg-[#202124] z-[100] sticky top-0 left-0">
					{/* TITLE */}
					<div className="flex justify-between items-center w-full py-4">
						<div className="text-[#F8F9FA] font-[500] text-[32px]">
							Spiritual
						</div>
					</div>

					{/* SEARCH FILTER */}
					<div className="w-full flex flex-row justify-between items-center py-1 transition-all duration-800 ease-in">
						<div className="w-full flex flex-row items-center text-white relative">
							<div
								className="absolute left-5 cursor-pointer"
								onClick={() => searchSpiritualContent()}
							>
								<IoSearchOutline size={40} />
							</div>

							<input
								className="w-full px-20 py-5 bg-[#2E3134] rounded-[70px] text-[24px] font-[400] text-white outline-none"
								type="search"
								placeholder="Search"
								onChange={(e) => handleSearchChange(e)}
								onKeyDown={(e) => handleKeyDown(e)}
							/>
						</div>
					</div>
				</div>
			</div>

			<div className="flex flex-row overflow-x-scroll w-[100vw] py-4 px-5 slider-container">
				{spiritualFilterData?.map((filter) => (		
					<div
						className={`flex flex-row justify-around items-center bg-[#2E3133] min-w-fit pl-2 pr-4 mr-4 py-6 rounded-[36px] cursor-pointer actor-btn ${
							selectedFilter === filter.name
								? "text-[#9CCDFB] border-[2px] border-[#9CCDFB]"
								: "text-white"
							} ${filter.name === 'For You' ? 'width-fit h-full': ''}`
						}
						onClick={() =>
							handleFilterClick(filter?.name)
						}
					>
						{filter.name !== 'For You' && <img src={filter.image} alt={filter.name} className="w-10 h-10 bg-white object-cover rounded-full"/>}
						<div className="text-[20px] pl-2 font-[400]">
							{filter.name}
						</div>
					</div>
								
							
				))}
			</div>

			{/* VIDEOS DISPLAY SECTION */}
			<div className="w-full h-full overflow-y-scroll scroll-container">
				{
					loading ? 
						<div className={`${loading ? 'w-full h-full flex flex-row justify-center items-center text-5xl font-bold text-white' : 'invisible w-0 h-0'}`}>
							<div className="spinner"></div>
						</div> 
						: videos?.length > 0 ? (
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full gap-x-[20px] gap-y-[24px] z-0 left-0 px-5 cursor-pointer">
							{videos?.map((video) => (
								<div
									className="flex flex-col gap-y-[12px] items-center"
									onClick={() =>
										navigate(
											`/youtubeVideo/video/${video?.vid?.videoId}`
										)
									}
								>
									<div className="w-full h-full">
										<img
											alt="movie-card"
											src={
												video?.snippet?.thumbnails?.high
													?.url
											}
											className="rounded-2xl w-full h-full "
										/>
									</div>
									<div className="text-white text-[24px] font-[500]">
										{video?.snippet?.title}
									</div>
								</div>
							))}
						</div>
					) : (
						<div className="w-full h-full flex flex-row justify-center items-center text-3xl text-white">
							No Bhajan Found !!
						</div>
					)
				}
			</div>
		</div>
	);
};

export default Spiritual;
